/**
 * Web Studio's tab keys, shared between the tab list (`index.tsx`) and any
 * page that needs to link back into a specific tab (e.g. the editor's
 * "back to Web Studio" navigation, which should return the user to the tab
 * they came from rather than always resetting to the first tab).
 */
export const WEB_STUDIO_TAB_KEYS = {
  WEB_STUDIO: 'web-studio',
  PAGES: 'pages',
  MENU: 'menu',
  COMPONENTS: 'components',
} as const;

export type WebStudioTabKey = typeof WEB_STUDIO_TAB_KEYS[keyof typeof WEB_STUDIO_TAB_KEYS];

const TAB_KEY_VALUES: readonly string[] = Object.values(WEB_STUDIO_TAB_KEYS);

/** Narrows an arbitrary string (e.g. a query param) to a known tab key, or undefined if unrecognized. */
export function toWebStudioTabKey(value: string | null | undefined): WebStudioTabKey | undefined {
  return TAB_KEY_VALUES.includes(value ?? '') ? (value as WebStudioTabKey) : undefined;
}
